require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/modules/es7.symbol.observable.js
// module id = 643
// module chunks = 0